import Vue from 'vue';
import VueRouter from 'vue-router';

// Paths

export const paths = Object.freeze({
  home: '/',
  map: '/map',
  schedule: '/schedule',
  enrollCategory: '/enrollCategory',
  enrollTraining: '/enrollTraining',
  enrollSchedule: '/enrollSchedule',
  enrollName: '/enrollName',
  enrollPhone: '/enrollPhone',
  trainings: '/trainings',
  training: '/training',
});

// Routes

export const routes = [
  {
    path: paths.home,
    name: 'Home',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Home.vue'),
    meta: {
      back: false,
    },
    props: true,
  },
  {
    path: paths.map,
    name: 'Map',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Map.vue'),
    meta: {
      back: paths.home,
    },
  },
  {
    path: paths.schedule,
    name: 'Schedule',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Schedule.vue'),
    meta: {
      back: paths.home,
    },
  },
  {
    path: paths.enrollCategory,
    name: 'EnrollCategory',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/EnrollCategory.vue'),
    meta: {
      back: paths.home,
    },
  },
  {
    path: paths.enrollTraining,
    name: 'EnrollTraining',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/EnrollTraining.vue'),
    meta: {
      back: paths.enrollCategory,
    },
  },
  {
    path: paths.enrollSchedule,
    name: 'EnrollSchedule',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/EnrollSchedule.vue'),
    meta: {
      back: paths.enrollTraining,
    },
  },
  {
    path: paths.enrollName,
    name: 'EnrollName',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/EnrollName.vue'),
    meta: {
      back: (vm) => (vm.isCameFromSchedule ? paths.schedule : paths.enrollSchedule),
    },
  },
  {
    path: paths.enrollPhone,
    name: 'EnrollPhone',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/EnrollPhone.vue'),
    meta: {
      back: paths.enrollName,
    },
  },
  {
    path: paths.trainings,
    name: 'Trainings',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Trainings.vue'),
    meta: {
      back: paths.home,
    },
  },
  {
    path: paths.training,
    name: 'Training',
    component: () => import(/* webpackChunkName: "screens" */ '@/screens/Training.vue'),
    meta: {
      back: paths.trainings,
    },
  },

];

// Router

Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: '_active',
  linkExactActiveClass: '_active_exact',
  paths,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
